import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../avatar/components/Avatar';
import Video from '../../../media/components/web/Video';
import { getLocalParticipant } from '../../../participants/functions';
import { getDisplayName } from '../../../settings/functions.web';
import { getLocalVideoTrack } from '../../../tracks/functions.web';
const useStyles = makeStyles()(theme => ({
    previewContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.ui02,
        zIndex: 251
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    avatar: {
        maxWidth: '200px',
        maxHeight: '200px',
        transform: 'translateY(-80px)' //ajuste: -40 / -60 / -80
    }
}));
/**
 * Component showing the video preview and device status.
 *
 * @param {IProps} props - The props of the component.
 * @returns {ReactElement}
 */
function Preview(props) {
    const { _participantId, flipVideo, name, videoMuted, videoTrack } = props;
    const { classes } = useStyles();
    const className = flipVideo ? 'flipVideoX' : '';
    useEffect(() => {
        if (typeof APP !== 'undefined') {
            APP.API.notifyPrejoinVideoVisibilityChanged(Boolean(!videoMuted && videoTrack));
        }
    }, [videoMuted, videoTrack]);
    useEffect(() => {
        if (typeof APP !== 'undefined') {
            APP.API.notifyPrejoinLoaded();
        }
        return () => {
            if (typeof APP !== 'undefined') {
                APP.API.notifyPrejoinVideoVisibilityChanged(false);
            }
        };
    }, []);
    return (React.createElement("div", { className: classes.previewContainer }, !videoMuted && videoTrack
        ? (React.createElement(Video, { className: `${classes.video} ${className}`, id: 'prejoinVideo', videoTrack: { jitsiTrack: videoTrack } }))
        : (React.createElement(Avatar, { className: `${classes.avatar} premeeting-screen-avatar`, displayName: name, participantId: _participantId, size: 200 }))));
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @param {IProps} ownProps - The own props of the component.
 * @returns {IProps}
 */
function _mapStateToProps(state, ownProps) {
    const name = getDisplayName(state);
    const { id: _participantId } = getLocalParticipant(state) ?? {};
    return {
        _participantId: _participantId ?? '',
        flipVideo: Boolean(state['features/base/settings'].localFlipX),
        name,
        videoMuted: ownProps.videoTrack ? ownProps.videoMuted : state['features/base/media'].video.muted,
        videoTrack: ownProps.videoTrack || getLocalVideoTrack(state['features/base/tracks'])?.jitsiTrack
    };
}
export default connect(_mapStateToProps)(Preview);
